import React from 'react';

export default function DuplicateSummaryCard({ summary, scanning, onScan, onScrollToGroups }) {
  const groups = summary?.groupCount ?? 0;
  const extras = summary?.duplicateEmails ?? 0;
  const totalDupMails = groups + extras;

  return (
    <div className="dup-kpi-row">
      <button type="button" className="dup-kpi-card" onClick={onScrollToGroups}>
        <div className="dup-kpi-icon dup-kpi-blue">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
          </svg>
        </div>
        <div className="dup-kpi-body">
          <span className="dup-kpi-label">Duplicate Groups</span>
          <strong className="dup-kpi-value">{groups}</strong>
          <span className="dup-kpi-link">View groups</span>
        </div>
      </button>

      <div className="dup-kpi-card">
        <div className="dup-kpi-icon dup-kpi-purple">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
          </svg>
        </div>
        <div className="dup-kpi-body">
          <span className="dup-kpi-label">Duplicate Emails</span>
          <strong className="dup-kpi-value">{totalDupMails}</strong>
          <span className="dup-kpi-sub">Total duplicates</span>
        </div>
      </div>

      <div className="dup-kpi-card">
        <div className="dup-kpi-icon dup-kpi-orange">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </div>
        <div className="dup-kpi-body">
          <span className="dup-kpi-label">Extra Copies</span>
          <strong className="dup-kpi-value">{extras}</strong>
          <span className="dup-kpi-sub">Can be cleaned</span>
        </div>
      </div>

      <div className="dup-kpi-card">
        <div className="dup-kpi-icon dup-kpi-green">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
          </svg>
        </div>
        <div className="dup-kpi-body">
          <span className="dup-kpi-label">Last Scan</span>
          <strong className="dup-kpi-value dup-kpi-value-sm">
            {summary?.lastScanAt
              ? new Date(summary.lastScanAt).toLocaleString([], {
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : 'Never'}
          </strong>
          <span className="dup-kpi-sub">View history</span>
        </div>
      </div>

      <div className="dup-kpi-card dup-kpi-scan">
        <div className="dup-kpi-body">
          <span className="dup-kpi-label">Ready to scan?</span>
          <strong className="dup-kpi-value dup-kpi-value-sm">
            {scanning ? 'Working…' : 'Find new duplicates'}
          </strong>
          <button
            type="button"
            className="dup-scan-now-btn"
            onClick={onScan}
            disabled={scanning}
          >
            {scanning ? 'Scanning…' : 'Scan Now'}
          </button>
        </div>
      </div>
    </div>
  );
}
